import global, { console } from 'window-or-global';
import { ContentClient } from 'dc-delivery-sdk-js';

export const getPropertyName = (property) => {
  const element = document.getElementById(`${property}-field`);

  return element ? element.innerText : '';
};

export const getBundlePath = (bundleName) =>
  window.NODE_ENV === 'development'
    ? `${window.location.protocol}//${window.location.hostname}:8080/theme-version2/dist/${bundleName}.js?v=${window.ASSET_VERSION}`
    : `/_ui/theme-version2/dist/${bundleName}.js?v=${window.ASSET_VERSION}`;

export const getSlotId = (propertyName) => {
  const slotIdPath = getPropertyName(propertyName);

  if (!slotIdPath) {
    return;
  }

  const slotRegExp = /(?:.(?!\/))+$/gm;
  const matched = slotRegExp.exec(slotIdPath);

  return matched.length ? matched[0].substr(1) : '';
};

export const loadStyles = (url) =>
  new Promise((resolve, reject) => {
    var styles = document.createElement('link');

    styles.rel = 'stylesheet';
    styles.href = url;
    styles.onload = () => resolve();
    styles.onerror = () => reject(new Error(`Cannot load styles: ${url}`));

    document.head.appendChild(styles);
  });

export const getDataBySlotId = (slotId) => {
  if (!global.amplienceDynamicContent || !global.amplienceDynamicContent[slotId] || !slotId) {
    return;
  }

  return global.amplienceDynamicContent[slotId];
};

// @TODO - to find/analyse a better way to cache responses by using one or mix of the options:
// 1 - use sessionStorage
// 2 - with PWA feature > service worker with backward compatibility support
// 3 - other options

export const fetchContentDataBySlotId = (slotId) => {
  global.amplienceDynamicContent = global.amplienceDynamicContent || {};
  const { amplienceStoreId: account = 'mulberrygroup' } = global;

  if (global.amplienceDynamicContent[slotId] && !slotId) {
    return;
  }

  const client = new ContentClient({ account });

  return client
    .getContentItemById(slotId)
    .then(({ body } = {}) => {
      global.amplienceDynamicContent[slotId] = body;
    })
    .catch((error) => {
      console.error('content not found', error);
    });
};

export const textFieldCharCount = (textArea) => {
  console.log('blah')
  textArea.parentNode.querySelector('.textAreaCharsRemaining').innerHTML = textArea.value.length;
};

export const fetchContentForLocal = (slotId) => {
  let amplienceDynamicContent;
  const { amplienceStoreId: account = 'mulberrygroup' } = global;

  const client = new ContentClient({ account });

  return client
    .getContentItemById(slotId)
    .then(({ body } = {}) => {
      return body;
    })
    .catch((error) => {
      console.error('content not found', error);
    });

  return amplienceDynamicContent;
};
